import { PERITADOR_CLEAN_REQUEST_LIST } from './constants'

export function cleanRequestList() {
  return (dispatch) => {
    dispatch({
        type: PERITADOR_CLEAN_REQUEST_LIST,
    })
  }
}

export function reducer(state, action) {
  if (action.type === PERITADOR_CLEAN_REQUEST_LIST) {
      return {
        ...state,
        requests: null,
      }
  } else {
      return state
  }
}